import Icon from '@components/Icon'
import Popover from '@components/Popover'
import BuyButtonCTA from 'map/components/actionButton/BuyButtonCTA'

const CarParkPopover = ({ canBuy, bookingUrl, buyLabel, name, opngo, externalSeasonTicketUrl, carParkUrl }) => (
    <Popover
        renderTitle={() => (
            <Link className="d-flex w-100" title={name} to={carParkUrl}>
                <span className="popover-title-name">{name}</span>
                <Icon type="info" size="xs" className="ml-auto" />
            </Link>
        )}
        renderContent={() => (
            <BuyButtonCTA
                canBuy={canBuy}
                bookingUrl={bookingUrl}
                buyLabel={buyLabel}
                opngo={opngo}
                externalSeasonTicketUrl={externalSeasonTicketUrl}
            />
        )}
    />
)

export default CarParkPopover
